import { render, staticRenderFns } from "./TownDescription.vue?vue&type=template&id=8a1b28c2"
import script from "./TownDescription.vue?vue&type=script&lang=js"
export * from "./TownDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports